const faecal_sludge_colorMap = {
    domain: ["Bucket and rope", "Cistern flush", "Double pit", "Drain", "Electric pump", "Manual pump", "Manual transport", "No containment", "No need to flush", "Pour flush", "Septic tank", "Single pit lined", "Single pit unlined/ dug hole", "Suction pump (Vacu-tug)", "Vacu-tug", "Van", "Carried away", "Dug hole", "Nearby waterbodies", "Not emptied", "Open ground", "River/Canal", "Desludger", "Treatment plant"],
    range: ["#FFBF00", "#238823", "#FFBF00", "#D2222D", "#238823", "#FFBF00", "#D2222D", "#D2222D", "#D2222D", "#238823", "#238823", "#FFBF00", "#D2222D", "#238823", "#238823", "#FFBF00", "#FFBF00", "#FFBF00", "#D2222D", "#AA8B00", "#D2222D", "#D2222D", "#238823", "#238823"],
}
const solid_waste_colorMap = {
    domain: ["HH Generation", "Municipality", "Private agency", "NGO", "Local clubs", "Self carried", " Van transport ", "Manual transport", "Nearby dustbin", "STS", "Drain", "Dug hole", "Open ground", "Roadside", "Waterbodies ", "Dumping site", "Treatment plant"],
    range: ["#238823", "#238823", "#238823", "#238823", "#238823", "#FFBF00", "#238823", "#FFBF00", "#238823", "#238823", "#D2222D", "#AA8B00", "#D2222D", "#D2222D", "#D2222D", "#FFBF00", "#238823"],
}


export const fetchSankeyData = async (payload, request) => {
    let data = undefined
    try {
        const response = await request("POST", `/v1/survey/dashboard/sankey`, { data: { "locationId": payload.locationId, "surveyId": payload.surveyId, "type": payload.type } }, "survey_service")

        if (response) {
            data = { ...response, "colorMap": payload.type === "Feacal_Sludge" ? faecal_sludge_colorMap : solid_waste_colorMap }
        }
        return data

    } catch (error) {


        return error

    }

}
